import { FC } from 'react'
import { Skeleton } from 'src/components/Skeleton'
import styles from './loadingSkeleton.module.scss'

// Brand-level page skeleton: title, the three stat cards, the two lower panels,
// the facility label and the platform card grid. The widgets it stands in for
// are presentational and are never mounted during the first load (see
// BrandLevelWidgets), so this is where the brand page reserves its space.
export const LoadingSkeleton: FC = () => (
  <div className={styles.wrapper}>
    <div className={styles.card}>
      <Skeleton height={22} width={180} />

      <div className={styles.statsRow}>
        {Array.from({ length: 3 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Skeleton height={120} key={index} radius={12} />
        ))}
      </div>

      <div className={styles.bottomRow}>
        <Skeleton height={160} radius={12} />
        <Skeleton height={160} radius={12} />
      </div>

      <Skeleton height={16} width={220} />

      <div className={styles.cardsGrid}>
        {Array.from({ length: 4 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Skeleton height={200} key={index} radius={12} />
        ))}
      </div>
    </div>
  </div>
)
